export class SrcParameter {
    name: string;
    children: SrcParameter[];
    constructionObject: any;


    constructor(name: string) {
        this.name = name;
        this.children = null;
        this.constructionObject = null;
    }

    public isMultiple(): boolean {
        return this.children === null ? false : true;
    }
    public setMultiple(): void {
        this.children = new Array();
    }

    public createChild(): any {
        let result = null;
        if (this.isMultiple()) {
            // tslint:disable-next-line:new-parens
            result = new (this.constructionObject);
            this.children.push(result);
        }
        return result;
    }
}
